import CloudinaryImage from "@/components/cloudinary-image";
import type { PhotoType } from "@/components/photos-list";
import { Button } from "@/components/ui/button";
import { DialogHeader, DialogTitle } from "@/components/ui/dialog";

import { CloseIcon } from "./icons";

interface GalleryProps {
  onClick(index: number): void;
  onClose(): void;
  photos: PhotoType[];
}

export default function Gallery({ onClick, onClose, photos }: GalleryProps) {
  const handleClick = (index: number) => () => onClick(index);

  return (
    <>
      <DialogHeader className="relative px-0 py-5 md:px-30 md:py-10">
        <DialogTitle className="text-center font-semibold text-16 text-white md:text-left md:text-24">
          {photos.length} Photo{photos.length === 1 ? "" : "s"}
        </DialogTitle>
        <Button
          aria-label="Close"
          className="absolute top-1/2 right-6 -mt-3 flex size-6 rounded-full border border-white/50 md:top-10 md:right-10 md:mt-0 md:size-7.5"
          onClick={onClose}
        >
          <CloseIcon />
        </Button>
      </DialogHeader>
      <div className="grid grid-cols-3 gap-2.5 px-2.5 md:grid-cols-5 md:gap-6 md:px-30">
        {photos.map(
          ({ imageId }, index) =>
            !!imageId && (
              <CloudinaryImage
                className="aspect-square cursor-pointer rounded-[5px] shadow-white/25 transition-shadow hover:shadow-0-0-20 md:rounded-[10px]"
                imageId={imageId}
                key={imageId}
                onClick={handleClick(index)}
                rW={880}
              />
            )
        )}
      </div>
    </>
  );
}
